module.exports = __webpack_public_path__ + "static/media/VectorPointInacabado17.9d4b6874.svg";